import getUserPermissions from 'modules/get-user-permissions/get-user-permissions';

function userHasPermission(permission) {
  return getUserPermissions().includes(permission);
}

export function hasPermissions(permissions) {
  const parsedData = JSON.parse(permissions);
  return 'dropshipments' in parsedData && !!parsedData['dropshipments']?.length;
}

export function canUploadFiles() {
  return userHasPermission('can_upload_files');
}

export function canPrintLabels() {
  return userHasPermission('can_print_labels');
}

export function canReprintLabels() {
  return userHasPermission('can_reprint_labels');
}

export function canRegisterShipments() {
  return userHasPermission('can_register_shipments');
}

export function canPickPreparationOrders() {
  return userHasPermission('can_pick_preparation_orders');
}

export function canTransferPreparationOrders() {
  return userHasPermission('can_transfer_preparation_orders');
}

export function canClosePreparationOrders() {
  return userHasPermission('can_close_preparation_orders');
}

export function canForceClosePreparationOrders() {
  return userHasPermission('can_force_close_preparation_orders');
}

export function canCreatePreparationOrders() {
  return userHasPermission('can_create_preparation_orders');
}

export function canCreateWorkingOrders() {
  return userHasPermission('can_create_working_orders');
}

export function canCreateSorterPreparationOrders() {
  return userHasPermission('can_create_sorter_preparation_orders');
}

export function cabRetryMarketplaceOrders() {
  return userHasPermission('can_retry_marketplace_orders');
}

export function canRetrySorterShipments() {
  return userHasPermission('can_retry_sorter_shipments');
}

export function isB2B() {
  return userHasPermission('is_b2b');
}

export function isB2BUploader() {
  return userHasPermission('is_b2b') && canUploadFiles();
}

export function isB2BRetry() {
  return (
    userHasPermission('is_b2b') &&
    canRegisterShipments() &&
    canCreatePreparationOrders()
  );
}

export function isSorterRetry() {
  return (
    canRetrySorterShipments &&
    canRegisterShipments() &&
    canCreateSorterPreparationOrders()
  );
}

export function isB2BPrinter() {
  return isB2B() && canPickPreparationOrders();
}

export function isSAT() {
  return userHasPermission('is_sat');
}

export function isDSV() {
  return userHasPermission('is_dsv');
}

export function isSFP() {
  return userHasPermission('is_sfp');
}

export function isOllas() {
  return userHasPermission('is_ollas');
}

export function isStock() {
  return userHasPermission('is_stock');
}

export function isAdmin() {
  return userHasPermission('is_admin');
}

export function isScanPack() {
  return userHasPermission('is_scanpack');
}

export function isBulkdrop() {
  return userHasPermission('is_bulkdrop');
}

export function isLolina() {
  return userHasPermission('is_lolina');
}

export function isSorter() {
  return userHasPermission('is_sorter');
}

export function isWarehouseManager() {
  return userHasPermission('is_warehouse_manager');
}

export function isStaff() {
  return userHasPermission('is_staff');
}

export function canRetryMarketplaceOrders() {
  return userHasPermission('can_retry_marketplace_orders');
}

export function isSATUploader() {
  return isSAT() && canUploadFiles();
}

export function isSATRetry() {
  return isSAT() && canRegisterShipments() && canCreateWorkingOrders();
}

export function isSATPrinter() {
  return isSAT() && (canPrintLabels() || canReprintLabels());
}

export function isDSVPrinter() {
  return isDSV() && (canPrintLabels() || canReprintLabels());
}

export function isDSVRetry() {
  return isDSV() && canRetryMarketplaceOrders();
}

export function isB2BStock() {
  return isB2B() && isStock();
}

export function isDSVStock() {
  return isDSV() && isStock();
}

export function isSFPStock() {
  return isSFP() && isStock();
}

export function isB2BReprint() {
  return (
    isB2B() &&
    canClosePreparationOrders() &&
    canPickPreparationOrders() &&
    canTransferPreparationOrders() &&
    canPrintLabels() &&
    canReprintLabels()
  );
}

export function canRetryShipments() {
  return isB2BRetry() || isOllas() || isSATRetry();
}
